// extracted by mini-css-extract-plugin
export var label = "_es-5";
export var slideContainer = "_es-0";
export var slider = "_es-1";
export var sliderLg = "_es-4";
export var sliderMd = "_es-3";
export var sliderSm = "_es-2";